export const copyToClipboard = (text: string) => navigator.clipboard.writeText(text);
export const copyEnrichTextToClipboard = (text: ClipboardItem[]) => navigator.clipboard.write(text);

export const copyUsingMode = async (
  mode: 'plaintext' | 'enriched-text',
  clipBoardItems: ClipboardItem[]
) => {
  if (mode === 'enriched-text') {
    copyEnrichTextToClipboard(clipBoardItems);
  } else {
    const temp = document.createElement('div');
    const htmls = await Promise.all(
      clipBoardItems.map((item) => item.getType('text/html').then((b) => b.text()))
    );
    temp.innerHTML = htmls.join('<br/>');

    copyToClipboard(
      temp.innerText
        .replace(/•/g, '\n•')
        .replace(/\*/g, '\n•')
        .split('\n')
        .map((line) => line.trim())
        .join('\n')
    );
  }
};
